import React, { createContext, useContext, useMemo, useState } from "react";
import { FailurePop, SuccessPop } from "../Popup";
import { AppContext } from "./app.context";

export const CartContext = createContext();

export const CartContextProvider = ({ children }) => {
  const { branchValue } = useContext(AppContext);

  //useState
  const [productCount, setProductCount] = useState(0);
  const [productCartList, setProductCartList] = useState([]);
  const [cartTab, setCartTab] = useState("Service");
  const [loader, setLoader] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalFail, setModalFail] = useState(false);
  const [content, setContent] = useState("");
  const [productTotal, setProductTotal] = useState(0);
  const [productOfferTotal, setProductOfferTotal] = useState(0);
  const [productSubTotal, setProductSubTotal] = useState(0);
  const [productTax, setProductTax] = useState(0);

  //OfferList
  const [offerList, setOfferList] = useState([]);
  const [offerLoader, setOfferLoader] = useState(false);

  //Functions
  const fetchProductCartList = async () => {
    try {
      const response = await global.$axios.get(
        `product/listCart/${global.$userData.id}`
      );
      if (response.data.status === "success") {
        setProductCartList(response.data.message);
        setProductCount(response.data.message.length);
        if (response.data.message?.length > 0)
          await fetchTotal(response.data.message);
      } else {
        console.log("Product Cart Issue", response.data.message);
      }
    } catch (error) {
      console.log("Product Cart Issue", error);
    }
  };

  const AddProductCart = async (item) => {
    try {
      const data = {
        customer_id: global.$userData.id,
        product_id: item?._id,

        product_subcat_id: item?.product_subcat_id,
        price: item?.customer_price,
        user_id: global.$userData.id,
        actual_price: item?.actual_price,
        tax_percentage: branchValue?.tax_type?.tax,
        taxAmount: item?.tax_amount,
        quantity: 1,
        increment: false,
      };

      const response = await global.$axios.post("product/addCart", data);
      if (response.data.status === "success") {
        setContent("Added to Cart");
        setModalSuccess(true);

        await fetchProductCartList();
        setCartTab("Product");
      } else {
        console.log("Product Add to cart Issue", response.data.message);
        setContent("Something Went Wrong, Try Again!");
        setModalFail(true);
      }
    } catch (error) {
      console.log("Product Add to cart Issue", error);
    }
  };

  const fetchTotal = async (data) => {
    const calcu = data?.reduce(
      (acc, item) => acc + Number(item.actual_price) * Number(item.quantity),
      0
    );
    const subCalcu = data?.reduce(
      (acc, item) => acc + Number(item.total_amount) * Number(item.quantity),
      0
    );
    const taxCalcu = data?.reduce(
      (acc, item) => acc + Number(item.tax_amount) * Number(item.quantity),
      0
    );

    const offer_cal = data?.reduce(
      (acc, item) =>
        acc +
        Number(
          item?.is_offer_service
            ? item?.discounted_price
            : item?.qty_actual_price
        ),
      0
    );

    setProductTotal(calcu);
    setProductOfferTotal(offer_cal);
    setProductSubTotal(subCalcu);
    setProductTax(taxCalcu);
  };

  const fetchOfferList = async () => {
    setOfferLoader(true);
    try {
      let dada = {
        branch_id: branchValue?._id,
        customer_id: global?.$userData.id,
      };
      const response = await global.$axios.post(
        `coupon_master/viewCoupon`,
        dada
      );
      let newArr = [];
      const firstOrderList = response?.data?.FirstCustomerCoupon;
      const NormalOrderList = response?.data?.NormalCouponList;

      if (firstOrderList?.length > 0) {
        newArr = [...firstOrderList, ...NormalOrderList];
      } else {
        newArr = [...NormalOrderList];
      }

      const groupedOffers = newArr?.reduce((acc, current) => {
        const type = current.type;
        if (!acc[type]) {
          acc[type] = [];
        }
        acc[type].push(current);
        return acc;
      }, {});
      setOfferList(groupedOffers);
      // console.log("fetchofferlist", JSON.stringify(newArr));
      setOfferLoader(false);
    } catch (error) {
      console.log("fetchofferlist", error);
      setOfferLoader(false);
    }
  };

  const values = useMemo(
    () => ({
      productCount,
      setProductCount,
      productCartList,
      productTotal,
      productOfferTotal,
      productSubTotal,
      productTax,
      fetchProductCartList,
      AddProductCart,
      cartTab,
      setCartTab,
      loader,
      fetchOfferList,
      offerLoader,
      offerList,
    }),
    [
      productCount,
      setProductCount,
      productCartList,
      productTotal,
      productOfferTotal,
      productSubTotal,
      productTax,
      fetchProductCartList,
      AddProductCart,
      cartTab,
      setCartTab,
      loader,
      offerLoader,
      offerList,
    ]
  );

  return (
    <>
      <CartContext.Provider value={values}>{children}</CartContext.Provider>
      {modalSuccess && (
        <SuccessPop
          modalSuccess={modalSuccess}
          setModalSuccess={setModalSuccess}
          content={content}
        />
      )}
      {modalFail && (
        <FailurePop
          modalFail={modalFail}
          setModalFail={setModalFail}
          content={content}
        />
      )}
    </>
  );
};
